import { format, getDay, parse, startOfWeek } from 'date-fns';
import { enUS as en } from 'date-fns/locale/en-US';
import { fr } from 'date-fns/locale/fr';
import { dateFnsLocalizer, Messages } from 'react-big-calendar';
import { translate } from '../../../i18n';

const locales = {
    fr,
    en
};

export const calendarLocalizer = dateFnsLocalizer({
    format,
    parse,
    startOfWeek,
    getDay,
    locales,
});
export const calendarMessages: Messages<any> = {
    today: translate('calendar.toolbar.today'),
    previous: translate('calendar.toolbar.previous'),
    next: translate('calendar.toolbar.next'),
    month: translate('calendar.toolbar.month'),
    week: translate('calendar.toolbar.week'),
    day: translate('calendar.toolbar.day'),
    showMore(count, remainingEvents, events) {
        return `+${count} ${translate('calendar.games')}`;
    },
};
export default function SharedCalendar() {
  return (
    <div>SharedCalendar</div>
  )
}
